// Atomic skeleton block — pulsing gray rectangle.
// Used by every screen's loading state so first-paint shows the
// shape of the content instead of zero-state real values flickering
// to the right values when the Supabase queries return.
//
// Tailwind's `animate-pulse` provides the breathing effect for free.
// The black/10 color is light enough to feel "loading" but not so
// dark it competes with real content alongside it.
export function Skeleton({ className = '' }) {
  return (
    <div
      className={`animate-pulse rounded bg-black/10 ${className}`}
      aria-hidden="true"
    />
  )
}

// Convenience: skeleton "card" matching the visual mass of a real
// content card (rounded-2xl border bg-white p-5). Used for top-of-
// screen summary placeholders.
export function SkeletonCard({ className = '' }) {
  return (
    <div
      className={`mx-4 mt-4 rounded-2xl border border-black/10 bg-white p-5 shadow-sm ${className}`}
      aria-hidden="true"
    >
      <Skeleton className="h-3 w-32" />
      <Skeleton className="mt-3 h-10 w-44" />
      <Skeleton className="mt-2 h-3 w-56" />
    </div>
  )
}

// List of N skeleton rows — used for entries / order lists where
// the layout is row-based and we want to hint at the count.
export function SkeletonList({ rows = 3, className = '' }) {
  return (
    <ul
      className={`overflow-hidden rounded-xl border border-black/10 ${className}`}
      aria-hidden="true"
    >
      {Array.from({ length: rows }).map((_, i) => (
        <li
          key={i}
          className="flex items-center justify-between gap-3 border-b border-black/5 px-4 py-3 last:border-b-0"
        >
          <div className="min-w-0 flex-1">
            <Skeleton className="h-4 w-3/5" />
            <Skeleton className="mt-1.5 h-3 w-2/5" />
          </div>
          <Skeleton className="h-4 w-16" />
        </li>
      ))}
    </ul>
  )
}
